import { useSearchParams, useNavigate } from 'react-router-dom'
import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { OperatorGroupPermission } from '@/schema'
import { Button } from '@/common/ui/button'
import { Badge } from '@/common/ui/badge'
import { ArrowLeft } from 'lucide-react'
import useQueryGetPlayersByTags from '../../api/hooks/useQueryGetPlayersByTags'
import useQueryGetPlayerTags from '../../api/hooks/useQueryGetPlayerTags'
import PlayersWithTagsListing from '../../components/PlayersWithTagsListing'

function PlayersWithTagsPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [searchParams] = useSearchParams()
	const navigate = useNavigate()

	const tagId = searchParams.get('tagIds')

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		search: searchQuery || undefined,
		tagId: tagId || undefined,
	}

	const { data, isLoading } = useQueryGetPlayersByTags(payload)
	const { data: allTags } = useQueryGetPlayerTags()

	// Find the current tag being viewed
	const currentTag = allTags?.find((tag) => tag.id === tagId)

	const handleBack = () => {
		navigate('/operator/tags')
	}

	return (
		<PageContainer>
			<div className="mb-4 flex items-center justify-between">
				<Button variant="outline" onClick={handleBack}>
					<ArrowLeft className="mr-2 h-4 w-4" />
					กลับ
				</Button>
				{currentTag && (
					<Badge
						variant="outline"
						style={{
							backgroundColor: currentTag.color || '#e5e7eb',
							borderColor: currentTag.color || '#e5e7eb',
						}}
						className="px-4 py-2 text-base font-medium text-white"
					>
						{currentTag.name} • {currentTag.playerCount} ผู้เล่น
					</Badge>
				)}
			</div>
			<PlayersWithTagsListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedPlayersWithTagsPage = withUserPermission(PlayersWithTagsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [OperatorGroupPermission.MANAGE_PLAYER_TAGS],
})

export default GuardedPlayersWithTagsPage
